module.exports = __webpack_public_path__ + "img/ana-big.c0938cf3.png";